module.exports = __webpack_public_path__ + "static/media/img-3.8968ecba.jpg";